import { notificationInstance } from '@/shared/api/api-instances/notification/api-instance';
import type { TimeInterval, TimeIntervalItem } from '../model/time-interval';
import type { AxiosRequestConfig } from 'axios';

export class TimeIntervalsApi {
  static getTimeIntervals(options: AxiosRequestConfig = {}) {
    return notificationInstance.get<TimeIntervalItem[]>(
      `/time_intervals`,
      options,
    );
  }

  static getTimeIntervalByID(id: string, options: AxiosRequestConfig = {}) {
    return notificationInstance.get<TimeInterval>(
      `/time_interval/${id}`,
      options,
    );
  }

  static updateTimeInterval(
    id: string,
    payload: Omit<TimeInterval, 'id'>,
    options: AxiosRequestConfig = {},
  ) {
    return notificationInstance.put(`/time_interval/${id}`, payload, options);
  }

  static createTimeInterval(
    payload: Omit<TimeInterval, 'id'>,
    options: AxiosRequestConfig = {},
  ) {
    return notificationInstance.post('/time_interval', payload, options);
  }

  static deleteTimeInterval(id: string, options: AxiosRequestConfig = {}) {
    return notificationInstance.delete<void>(`/time_interval/${id}`, options);
  }
}